<template>
  <!-- 功能列表 + 示例图区域 -->
  <section class="features-section">
    <div class="container">
      <div class="row">
        <div class="col-md-6 d-flex justify-content-center align-items-center">
          <div class="pos-content">
            <div class="d-flex flex-column" v-for="item in posFeatures">
              <div class="d-flex justify-content-between">
                <div v-bind:class="{ 'pos-title': item.isShow }">{{ item.title }}</div>
                <div v-show="item.isShow" @click="showPosFeatures(false, item)"><img class="submenu-icon" src="@/assets/uupay/icon/svg/minus.svg" ></div>
                <div v-show="!item.isShow" @click="showPosFeatures(true, item)"><img class="submenu-icon" src="@/assets/uupay/icon/svg/plus.svg" ></div>
              </div>
              <div class="pos-subtitle" v-show="item.isShow">{{ item.subtitle }}</div>
              <el-divider></el-divider>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <img src="@/assets/uupay/images/pos_machine.png" alt="feature-img" class="img-fluid pos-img">
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'UUPayHomeFeature',
  data() {
    return {
      posFeatures: [
        {id: 1, title: 'POS系統無縫整合', subtitle: '產品與超過xx款POS合作 提供全面服務', isShow: false},
        {id: 2, title: '靈活結算週期', subtitle: '提供T=0結算方式 提升商家流動資金值', isShow: false},
        {id: 3, title: '實時數據與自動化報表', subtitle: '於UUPAY app 平台能隨時查看實時線上線下交易數據報表 提供清晰漏洞 核數更快', isShow: false},
        {id: 4, title: '行業定製方案', subtitle: '提供全面收付款方案 切合不同業務類型需求', isShow: false},
      ],
    }
  },
  methods: {
    showPosFeatures(isShow, item) {
      item.isShow = isShow
    }
  }
}
</script>
<style scoped>
  .features-section {
    margin: 100px 0;
  }
  .features-section .pos-content {
    width: 400px;
    margin: 0 auto;
    font-size: 22px;
    line-height: 40px;
    color: #21042E;
  }
  .features-section .pos-content .pos-title {color: #9A307A;}
  .features-section .pos-content .pos-subtitle {
    font-size: 12px;
    line-height: 20px;
    color: #4D4D4D;
  }
  .features-section .pos-img {
    width: 580px;
  }
</style>


// WEBPACK FOOTER //
// src/components/uupayHomeFeature.vue